export default "__VITE_ASSET__BevfaGJC__"